<itl-select-modal-item icon="alberta-hammer-outline" [title]="title" [subTitle]="subTitle"> </itl-select-modal-item>
